import axios from 'axios'
import {serialize} from '@/util'
import {getToken} from './auth'
import oauth from './oauth'

axios.defaults.timeout = 60 * 1000 * 5; //响应超时时间    

//请求拦截器
axios.interceptors.request.use(
  config => {
    if (!config.headers.Authorization) {
      config.headers.Authorization = getToken()
    }
    //在data里的isSerialize是true的话 就 序列化 data
    if (config.method === 'post' && config.data.isSerialize) {
      config.data = serialize(config.data);
    }

    return config
  },
  err => {
    return Promise.reject(err)
  }
);
 
function dealRequest(url,params,funName ) {
  return new Promise((resolve, reject) => {
    // if(isLoading) {
    //   loading = Loading.service({
    //     lock: true,
    //     text: '加载中...',
    //     spinner: 'el-loading-spinner',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   })    
    // }
    axios[funName](url, params)
      .then(response => {
        resolve(response.data)
      },(err)=>{
        reject(err)
      })
      .catch((err) => {
        console.error(err)
      })
  })
}
//添加响应拦截器
axios.interceptors.response.use((res) =>{
  
  if(res.data.code === 401) {
    return new Promise((resolve) => {
      oauth().then(auth => {
        if(auth) {
          res.config.headers.Authorization = auth
          resolve(axios.request(res.config))
        }
        return auth
      })
    })
  }
  return Promise.resolve(res)
}, (error) => { 
  return Promise.reject(error)
})
//返回一个Promise(发送post请求)
export function post(url, params,isLoading = true) {
  return dealRequest(url,params,"post",isLoading);
}
//返回一个Promise(发送get请求)
export function get(url,params,isLoading = true) {
  return dealRequest(url, {params},"get",isLoading);
}
//返回一个Promise(发送put请求)
export function put(url, params, isLoading = true) {
  return dealRequest(url, params, "put", isLoading);
}
//返回一个Promise(发送delete请求)
export function del(url, params, isLoading = true) {
  return dealRequest(url, {params}, "delete", isLoading);
}
export default {
  post,
  get,
  put,
  del,
}